import { MainContent, Template } from 'components';
import { useInitPage } from 'hooks';
import React from 'react';
import { FORM_PAGE_TYPE } from 'shared';
import { ReCaptchaGlobalStyles } from '../shared';

export const Complete: React.FC = () => {
  const { currentFormPage, mainContentRef } = useInitPage();
  if (!currentFormPage) {
    return null;
  }
  const { design, header, footer, title, message, pageId } = currentFormPage;
  return (
    <>
      <ReCaptchaGlobalStyles reCaptchaSetting={undefined} />
      <Template header={header} footer={footer} design={design}>
        <MainContent
          title={title}
          message={message}
          pageType={FORM_PAGE_TYPE.COMPLETE}
          pageId={pageId}
          design={design}
          ref={mainContentRef}
        />
      </Template>
    </>
  );
};
